import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";

type StatsRow = {
  user_id: string | null;
  bonus_count: number | null;
  claimed_this_month: number | null;
  approved_this_month: number | null;
  approved_total: number | null;
  avg_day_rate: number | null;
  total_earned: number | null;
  earned_mtd: number | null;
  earned_ytd: number | null;
};

type TopRow = {
  school_id: string | null;
  school_name: string | null;
  jobs_count: number | null;
};

type Response = {
  stats: StatsRow | null;
  top_schools: TopRow[];
};

// Per-substitute analytics from GET /api/stats/substitute. Defaults to the
// caller; superusers can pass ?id=<sub_id> to view any sub.
export const substitute_stats: Query<Ctx> = async ({ sb }, params) => {
  const id = params.get("id");
  const path = id
    ? `api/stats/substitute?id=${encodeURIComponent(id)}`
    : "api/stats/substitute";

  const { data } = await sb.functions.invoke<Response>(path, {
    method: "GET",
  });

  const row = data?.stats ?? null;
  const topRows = data?.top_schools ?? [];

  return {
    bonus_count: row ? Number(row.bonus_count ?? 0) : null,
    claimed_this_month: row ? Number(row.claimed_this_month ?? 0) : null,
    approved_this_month: row ? Number(row.approved_this_month ?? 0) : null,
    approved_total: row ? Number(row.approved_total ?? 0) : null,
    avg_day_rate:
      row && row.avg_day_rate !== null ? Number(row.avg_day_rate) : null,
    total_earned: row ? Number(row.total_earned ?? 0) : null,
    earned_mtd: row ? Number(row.earned_mtd ?? 0) : null,
    earned_ytd: row ? Number(row.earned_ytd ?? 0) : null,
    school1: topRows[0]?.school_name ?? null,
    school1_value: topRows[0]?.jobs_count ?? null,
    school2: topRows[1]?.school_name ?? null,
    school2_value: topRows[1]?.jobs_count ?? null,
    school3: topRows[2]?.school_name ?? null,
    school3_value: topRows[2]?.jobs_count ?? null,
  };
};
